export default __webpack_public_path__ + "static/media/3042.41b249c1.jpg";